const tagDefault = {

}

export const tagLite = {
    defaultBg: 'rgba(248, 248, 248, 1)',
    defaultColor: 'rgba(41, 39, 26, 1)',
}

export const tagDark = {
    ...tagDefault,
}